export default {
  REGISTER_LAST_ACCESS: 'REGISTER_LAST_ACCESS'
}
